export const COUNTRY_LOOKUP = [
	{
		value: 'USA',
		id: 'USA',
	},
	{
		value: 'Canada',
		id: 'Canada',
	},
	{
		value: 'UK',
		id: 'UK',
	},
	{
		value: 'Brazil',
		id: 'Brazil',
	},
	{
		value: 'India',
		id: 'India',
	},
	{
		value: 'South Africa',
		id: 'South Africa',
	},
	{
		value: 'Japan',
		id: 'Japan',
	},
	{
		value: 'China',
		id: 'China',
	},
	{
		value: 'UAE',
		id: 'UAE',
	},
	{
		value: 'Nepal',
		id: 'Nepal',
	},
	{
		value: 'Spain',
		id: 'Spain',
	},
	{
		value: 'Russia',
		id: 'Russia',
	},
	{
		value: 'Germany',
		id: 'Germany',
	},
	{
		value: 'Turkey',
		id: 'Turkey',
	},
	{
		value: 'Austria',
		id: 'Austria',
	},
	{
		value: 'Greece',
		id: 'Greece',
	},
	{
		value: 'NewZealand',
		id: 'NewZealand',
	},
	{
		value: 'Serbia',
		id: 'Serbia',
	},
	{
		value: 'France',
		id: 'France',
	},
];
